/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Row,
} from 'antd';
import { getModelPermission } from 'utils/permission';
import { checkToken } from 'api/utils';
import { formatReceived } from 'utils/formatValues';
import Table from 'components/Table';
import { getHistoricosLiquidaciones } from 'api/nominas/liquidaciones/historicoLiquidaciones';
import { getMotivosDeLiquidaciones } from 'api/catalogos/motivosDeLiquidaciones';
import { getEstadosGlobales } from 'api/catalogos';
import currencyFormatter from 'utils/currencyFormatter';
import { getLiquidaciones } from 'api/nominas/liquidaciones/liquidaciones';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const HistoricoLiquidacionPermission = {
  permissionModel: 'historicoliquidacion',
  catalogsModels: [],
  tabsModels: [],
};

const ExpedienteLiquidaciones = ({ currentEmpleado }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [motivosLiquidaciones, setMotivosLiquidaciones] = useState([]);
  const [estados, setEstados] = useState([]);

  const getPermission = getModelPermission(
    HistoricoLiquidacionPermission.permissionModel,
    HistoricoLiquidacionPermission.catalogsModels,
    HistoricoLiquidacionPermission.tabsModels,
    false,
  );

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _liquidacones,
        _motivos_liquidaciones,
        _estados,
        _data,
      ] = await Promise.all([
        getLiquidaciones(),
        getMotivosDeLiquidaciones({ estados_globales: ESTATUS_AUTORIZADO }),
        getEstadosGlobales(),
        getHistoricosLiquidaciones({ empleado: currentEmpleado }),
      ]);
      if (mounted) {
        setLiquidaciones(_liquidacones);
        setMotivosLiquidaciones(_motivos_liquidaciones);
        setEstados(_estados);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const columns = [
    {
      titleText: 'Antigüedad ',
      dataIndex: 'antiguedad',
      key: 'antiguedad',
      width: 200,
    },
    {
      titleText: 'Motivo de Liquidación ',
      dataIndex: 'liquidacion',
      key: 'liquidacion',
      width: 300,
      render: (val) => {
        const liqEmp = liquidaciones?.find((liq) => liq?.id === val);
        const motivoLiqEmp = motivosLiquidaciones?.find((motivoLiq) => motivoLiq?.id === liqEmp?.motivo_de_liquidacion);
        return `${liqEmp?.clave} - ${motivoLiqEmp?.motivo}`;
      },
    },
    {
      titleText: 'Importe de Finiquito ',
      dataIndex: 'importe_finiquito',
      key: 'importe_finiquito',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe de Indemnización ',
      dataIndex: 'importe_indemnizacion',
      key: 'importe_indemnizacion',
      width: 250,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe Deducciones ',
      dataIndex: 'importe_deducciones',
      key: 'importe_deducciones',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe Descuentos ',
      dataIndex: 'importe_descuentos',
      key: 'importe_descuentos',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe Neto ',
      dataIndex: 'importe_neto',
      key: 'importe_neto',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados?.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Table
        cols={columns}
        data={data.reverse()}
        permission={getPermission}
        allowExportParam={false}
        loading={loading}
      />
    </Row>
  );
};

export default ExpedienteLiquidaciones;
